/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
(function ($) {
  'use strict';
  app.Filters.CheckboxListView = app.Filters.SectionFilterView.extend({
    events: {
      'click .filter-show, .filter-hide': 'filterToggle',
      'click .filter-hide': 'scrollTop',
      'keyup .search-input': 'handleSearch',
      'click .reset-search': 'resetSearch',
      'change .search-input': 'handleSearchChange',
      'change input[type="checkbox"]': 'handleCheckboxChange',
      'click .js-toggle': 'toggleAll',
    },
    searchBarEnabled: false,
    shouldApplySearchBar: true,
    additionalOptions: [
      'object',
      'parent',
      'shouldApplySearchBar',
      'filtersInOneRow',
    ],
    // Максимальное количество показываемых сразу фильтров.
    MAX_FILTER_SHOWN: 5,
    // Количество фильтров, необходимое для появления поисковой строки.
    FILTERS_NEEDED_TO_APPLY_SEARCH: 20,
    models: [],
    /**
     * @inheritDoc
     */
    beforeRun: function () {
      this.template = app.helpers.TemplateHelper.getTemplate('#list-filter-view');
    },
    /**
     * @inheritDoc
     */
    run: function (data) {
      this.isNewFiltersAppearance = app.features && app.features.is_new_filters_appearance;
      _.extend(this.events, app.Filters.SectionFilterView.prototype.events);

      this.name = this.object.name;
      if (this.model) {
        this.models = this.model.get('mas');
      }
      if (this.parent) {
        this.parent.append(
          this.template(data)
        );
      }
      this.setElement($('#' + this.name));
      this.$blockBeforeSearchBar = this.$('.js-after-search-block');
      this.searchBlockTemplate = app.helpers.TemplateHelper.getTemplate('#filter-search-block');
      this.searchNothingFoundTemplate = app.helpers.TemplateHelper.getTemplate('#filter-search-nothing-found');
      this.buttonsTemplate = app.helpers.TemplateHelper.getTemplate('#filter-buttons-block');
      this.checkboxTemplate = app.helpers.TemplateHelper.getTemplate('#list-item-filter-view');
      this.setStateFromSS();
      this.listenTo(Backbone, 'filters-apply', this.unwrapFromScrollContainer);
    },

    /**
     * Рендер списка чекбоксов.
     */
    renderList: function () {
      var sum = '';
      var container = this.$('#' + this.name + '-list');

      if (container.length) {
        _.each(this.models, function (model) {
          var object = model.get('object');
          if (object) {
            if (object.title) {
              object.title = object.title.replace('/', '/ ');
            }
            sum += this.checkboxTemplate({
              object: object,
              className: model.get('className'),
            });
          }
        }.bind(this));
      }
      container.append(sum);
    },

    /**
     * Ищем состояние фильтра в sessionStorage и сохраняем в глобальной переменной.
     */
    setStateFromSS: function () {
      if (!app.filtersScrollState) {
        app.filtersScrollState = app.helpers.StorageHelper.SS.get('filtersScrollState') || {};
        if (this.isNewFiltersAppearance) {
          app.filtersScrollState = {};
        }
      }
      if (!app.filtersScrollState[this.name]) {
        app.filtersScrollState[this.name] = {'wrapped': false};
      }
      if (app.filtersScrollState[this.name] && app.filtersScrollState[this.name].scrollPos) {
        this.scrollTop = app.filtersScrollState[this.name].scrollPos;
      }
      if (!app.activeSearchState) {
        app.activeSearchState = {};
      }
      if (app.activeSearchState[this.name]) {
        this.activeSearchQuery = app.activeSearchState[this.name];
      }
    },
    /**
     * Скрываем фильтры или показываем в контейнере со скроллом, если их больше чем this.MAX_FILTER_SHOWN.
     */
    wrapFilters: function () {
      var list = this.$('.section-inside')[0],
        length = list ? list.children.length : 0,
        max = this.MAX_FILTER_SHOWN,
        filtersHidden = length - max,
        needScroll = app.filtersScrollState[this.name].wrapped,
        hasSelectedMoreThanMax = this.object.selectedQty && !this.hasSelectedFiltersInAlwaysVisiblePart(max),
        isInClosedState,
        action,
        showDisplayClass,
        hideDisplayClass;
      if (this.isNewFiltersAppearance) {
        max += 1;
      }
      // убираем выделение жирным для фильтров
      if (this.object.data_type && this.object.data_type !== 'option'
        || this.object.is_option_by_priority
        || length <= this.MAX_FILTER_SHOWN) {
        $(list).addClass('not-emphasized');
      }
      if (this.$('.section-inside').data('isShoes')) {
        max = Infinity;
      }
      if (length > max) {
        isInClosedState = (!needScroll
          || length < 10
          || !this.object.opened)
          && !hasSelectedMoreThanMax;
        if (isInClosedState) {
          action = 'removeClass';
          showDisplayClass = '';
          hideDisplayClass = 'not_display';
          this.$blockBeforeSearchBar.find('.js-toggle').addClass('not_display');
        } else {
          action = 'addClass';
          showDisplayClass = 'not_display';
          hideDisplayClass = '';
          this.$blockBeforeSearchBar.find('.js-toggle').removeClass('not_display');
        }
        if (this.object.name !== 'trademark') {
          $(list)[action]('emphasized-filters');
        }
        $(list).siblings('.side-filter-controls').html(this.buttonsTemplate({
          showDisplayClass: showDisplayClass,
          hideDisplayClass: hideDisplayClass,
          filtersHidden: filtersHidden,
        }));
        if (this.isNewFiltersAppearance && this.model) {
          needScroll = this.model.get('unwrapped');
        }
        if (!needScroll || length < 10 || !this.object.opened) {
          if (!hasSelectedMoreThanMax) {
            for (var i = this.MAX_FILTER_SHOWN; i < length; i++) {
              $(list.children[i]).addClass('not_display');
            }
          }
        } else {
          this.wrapToScrollContainer($(list), length);
          if (this.shouldApplySearchBar && length > this.FILTERS_NEEDED_TO_APPLY_SEARCH) {
            this.applySearchBar($(list));
          }
          if (this.activeSearchQuery) {
            this.$('.search-input').val(this.activeSearchQuery);
            this.filterCheckboxes(this.activeSearchQuery);
          }
        }
      }
    },

    /**
     * Проверяет есть ли выбранные фильтры в постоянно видимой части списка.
     *
     * @param max (int)
     * @return {boolean}
     */
    hasSelectedFiltersInAlwaysVisiblePart: function (max) {
      var result = false;
      for (var i = 0; i < max; i++) {
        if (this.object.values[i].selected) {
          result = true;
          break;
        }
      }
      return result;
    },
    /**
     * Сохраняем текущий поисковый запрос
     * @param {String} query
     * @param {Number} matchedCounter
     */
    saveSearchQuery: function (query, matchedCounter) {
      if (matchedCounter) {
        var filterSearchState = {};
        filterSearchState[this.name] = query;
        _.merge(app.activeSearchState, filterSearchState);
      } else {
        delete app.activeSearchState[this.name];
      }
    },
    /**
     * Обрабатываем набор символов в поисковой строке
     * @param {Event} e
     */
    handleSearch: function (e) {
      e.stopPropagation();
      e.preventDefault();
      var query = String($(e.currentTarget).val()).toLowerCase();
      if (e.keyCode === app.KEY_CODES.Escape) {
        query = '';
        this.$('.search-input').val('');
      }
      this.filterCheckboxes(query);
    },
    /**
     * Сбрасываем поисковую строку в дефолтное состояние
     * @param {Event} e
     */
    resetSearch: function (e) {
      e.stopPropagation();
      e.preventDefault();
      this.$('.search-input').val('');
      this.filterCheckboxes('');
    },
    /**
     * Блокируем всплытие события change для поисковой строки.
     * @param {Event} e
     */
    handleSearchChange: function (e) {
      e.stopPropagation();
      e.preventDefault();
    },
    /**
     * Фильтруем чекбоксы на основании запроса в поисковой строке
     * @param {String} [query] запрос в поисковой строке
     */
    filterCheckboxes: function (query) {
      var checkboxes = this.$('.section-inside label'),
        matchedCounter = 0,
        trademarkHeaders = this.$('.trademark-header'),
        filtersAfterTrademarkHeaders = 0,
        action = query ? 'removeClass' : 'addClass';
      _.each(checkboxes, function (checkbox) {
        var filterName = String($(checkbox).data('title')).toLowerCase();
        if (_.includes(filterName, query)) {
          $(checkbox).removeClass('not_display');
          if (query) {
            $(checkbox).unhighlight();
            $(checkbox).highlight(query);
            matchedCounter++;
          } else {
            $(checkbox).unhighlight();
          }
        } else {
          $(checkbox).addClass('not_display');
        }
      });
      this.saveSearchQuery(query, matchedCounter);

      this.$('.reset-search')[action]('not_display');

      if (query && !matchedCounter) {
        if (!this.nothingFoundShown) {
          this.$('.filter-search').after(this.searchNothingFoundTemplate());
          this.nothingFoundShown = true;
        }
      } else {
        this.$('.nothing-found').remove();
        this.nothingFoundShown = false;
      }
      if (trademarkHeaders.length) {
          // проверяем, что есть активные фильтры и в Наших и в Других
          trademarkHeaders.each(function (index, el) {
            if ($(el).nextUntil('.trademark-header', ':not(.not_display)').length) {
              filtersAfterTrademarkHeaders += 1;
            }
          });
        if (filtersAfterTrademarkHeaders < 2) {
          trademarkHeaders.hide();
        } else {
          trademarkHeaders.show();
        }
      }
    },
    /**
     * Добавляем поисковую строку перед определённым элементом.
     * @param {jQuery} container - элемент перед которым вставится поле поиска.
     */
    applySearchBar: function (container) {
      if (this.$blockBeforeSearchBar.length) {
        $(this.searchBlockTemplate()).insertBefore(this.$blockBeforeSearchBar);
      } else {
        $(this.searchBlockTemplate()).insertBefore(container);
      }
      this.searchBarEnabled = true;
    },
    /**
     * Удаляем поисковую строку и возвращаем видимость всем отфильтрованным элементам.
     */
    removeSearchBar: function () {
      var checkboxes = this.$('.section-inside label');
      _.each(checkboxes, function (checkbox) {
        $(checkbox).removeClass('not_display').unhighlight();
      });
      this.$('.filter-search').remove();
      this.$('.nothing-found').remove();
    },
    /**
     * Показывает или скрывает фильтры, если их слишком много (на основе параметра this.MAX_FILTER_SHOWN)
     * Если фильтров больше 10, показывает их в контейнере со скроллом.
     * @param {Event} e
     */
    filterToggle: function (e) {
      e.preventDefault();
      if (this.searchBarEnabled) {
        this.removeSearchBar();
        this.searchBarEnabled = false;
      }

      var controls = this.$('.side-filter-controls');
      this.needScroll = true;
      this.unwrapFromScrollContainer();
      if (this.model) {
        this.model.set({ unwrapped: false });
      }
      var container = this.$('.section-inside'),
        filters = container.children(),
        length = filters.length;
      for (var i = this.MAX_FILTER_SHOWN; i < length; i++) {
        var filter = filters[i];
        $(filter).toggleClass('not_display');
      }
      controls.children().toggleClass('not_display');
      this.$blockBeforeSearchBar.find('.js-toggle').toggleClass('not_display');

      if (this.object.name !== 'trademark') {
        container.toggleClass('emphasized-filters');
      }
      // проверяем не вышли ли фильтры за пределы
      var overflowedElementsCount = app.helpers.DomHelper.getOverflowedElements(container[0]).length;
      if (this.needScroll && (length > 10 || overflowedElementsCount)) {
        this.wrapToScrollContainer(container);
        if (this.model) {
          this.model.set({ unwrapped: true });
        }
        if (this.shouldApplySearchBar && length > this.FILTERS_NEEDED_TO_APPLY_SEARCH) {
          this.applySearchBar(container);
        }
      } else if (length < 10) {
        container.css('max-height', 'none');
      }

      app.EventBus.trigger('filter.section.toggle.side', e);
    },
    /**
     * Убираем возможность скролла
     * Сохраняем состояние в SessionStorage
     * @param {String} [onApply]
     */
    unwrapFromScrollContainer: function (onApply) {
      this.scrollTop = this.$('.section-inside').scrollTop();
      if (this.withScroll) {
        this.withScroll = null;
        this.needScroll = false;
        if (onApply !== 'applied') {
          app.filtersScrollState[this.name].wrapped = false;
        }
        app.filtersScrollState[this.name].scrollPos = this.scrollTop;
        app.helpers.StorageHelper.SS.set('filtersScrollState', app.filtersScrollState);
      }
    },
    /**
     * Оборачиваем в контейнер со скроллом
     * Сохраняем состояние в SessionStorage
     * @param {jQuery} container
     */
    wrapToScrollContainer: function (container) {
      var start = this.scrollTop ? this.scrollTop : 0;
      container.scrollTop(start);
      this.withScroll = true;
      app.filtersScrollState[this.name].wrapped = true;
      app.helpers.StorageHelper.SS.set('filtersScrollState', app.filtersScrollState);
    },
    /**
     * Прокручиваем экран вверх
     */
    scrollTop: function () {
      if (app.isMobile) {
        $('html, body').animate({
          scrollTop: $(this.el).offset().top,
        }, 200);
      }
    },

    /**
     * Обработка изменения чекбокса.
     * @param e - событие изменения.
     */
    handleCheckboxChange: function (e) {
      var inputName = e.currentTarget.name;
      var changedModel = _.find(this.models, function (model) {
        return String(model.get('object').name) === String(inputName);
      });
      if (changedModel) {
        changedModel.set('value', e.currentTarget.checked);
      }
      this.sendToOko();
    },

    /**
     * Отправляем в око название фильтра, в котором применили поиск.
     */
    sendToOko: function () {
      if (this.searchBarEnabled && app.activeSearchState[this.name]) {
        app.helpers.OkoHelper.push({
          "n": "custom",
          "category": "filter_search",
          "custom_str": this.name,
        });
      }
    },
    /**
     * Выбор или сброс всех значений фильтра.
     * @param {Event} e
     */
    toggleAll: function (e) {
      e.stopPropagation();
      var value = !$(e.currentTarget).data('reset'),
      inputs = this.$('input[type=checkbox]:enabled');
      inputs.prop('checked', value);
      var selectables = this.model.get('mas').filter(function (model) {
        return model.get('object').selectable;
      });
      _.each(selectables, function (model) {
        model.set({value: value});
      });
      inputs.first().trigger('change');
    },
  });
})(jQuery);


}.call(window));